import { render } from "./stepsItems.vue?vue&type=template&id=1a6c35a6&scoped=true"
import script from "./stepsItems.vue?vue&type=script&lang=js"
export * from "./stepsItems.vue?vue&type=script&lang=js"

import "./stepsItems.vue?vue&type=style&index=0&id=1a6c35a6&scoped=true&lang=css"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a6c35a6"]])

export default __exports__